// All colors reference theme tokens — no hardcoded hex
export const ROLE_LOADER_CONFIG = {
  PMO: {
    colorToken:   "steel",     // t.steel
    color2Token:  "steel2",    // t.steel2
    label:        "PMO",
    message:      "Loading your dashboard",
  },
  SCG: {
    colorToken:   "accent",    // t.accent (teal)
    color2Token:  "accent2",
    label:        "SCG",
    message:      "Preparing your workspace",
  },
  MAC_LEADER: {
    colorToken:   "purple",    // t.purple
    color2Token:  "purple2",
    label:        "MAC Leadership",
    message:      "Initializing your portal",
  },
  ADMIN: {
    colorToken:   "gold",      // t.gold
    color2Token:  "gold2",
    label:        "Administration",
    message:      "Securing your session",
  },
  DEFAULT: {
    colorToken:   "accent",
    color2Token:  "accent2",
    label:        "PSI360",
    message:      "Loading your workspace",
  },
};